module.exports = __webpack_public_path__ + "img/509f8c1.png";